import React, {useEffect, useState} from 'react';
import {byAPrefix, byCodes, getPostNum} from "../../../../constant/General";
import {getDate, getTime, getTimeFull} from "../../../../constant/DateUtils";

const RenderPosA = ({
                        posts,
                        mr = "19px",
                        field = "twoD",
                        width = "140px",
                        height = "94px",
                        fontSize = "90px",
                        marginLeft = "20px",
                        marginTop = "9px"
                    }) => {
    return <div style={{
        marginTop: marginTop,
        marginLeft: marginLeft,
        fontSize: fontSize
    }} className="text-black custom-postA ">
        {posts.map((post, i) => {
            return <div key={i} className="num-postA" style={{
                marginRight: mr, width: width, height: height
            }}>{getPostNum(post[field])}</div>
        })}
    </div>
}

const LiveResult = ({rightResults, drawAt}) => {
    const [timer, setTimer] = useState(getTimeFull());
    const post = {
        postBCD: byCodes(rightResults, ["B", "C", "D"]),
        postA3D: byAPrefix(rightResults, 3),
        postA2D: byAPrefix(rightResults, 4),
    };

    useEffect(() => {
        const interval = setInterval(() => {
            setTimer(getTimeFull());
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    return (
        <div className="w-50 overflow-hidden d-flex justify-content-center align-items-center text-black"
             style={{position: "relative"}}>
            <div className="w-100 h-100">
                <div className="live-timer">{timer}</div>
                <div className="date-wrap">
                    <div className="live-current-date">{getDate(drawAt)}</div>
                    <div className="live-current-time">{getTime(drawAt)}</div>
                </div>
                <RenderPosA mr="8px"
                            fontSize="70px"
                            width="134px"
                            marginLeft="195px"
                            posts={post.postA3D}
                            field="threeD"/>

                <RenderPosA
                    fontSize="80px"
                    width="143px"
                    mr="7px"
                    marginTop="6px"
                    posts={post.postA2D}/>

                <div style={{
                    fontSize: "80px",
                    marginTop: "18px",
                    marginLeft: "209px"
                }} className="post-tc custom-postBCD text-black">
                    {post.postBCD.map((post, i) => {
                        return <div
                            style={{
                                height: "88px", display: "flex", marginBottom: "8px"
                            }} key={i}>
                            <div className="cen-div" style={{
                                marginRight: "17px", width: "144px"
                            }}>{getPostNum(post.twoD)}</div>
                            <div className="cen-div" style={{width: "240px"}}>{getPostNum(post.threeD)}</div>
                        </div>
                    })}
                </div>
            </div>
        </div>
    )
};

export default LiveResult;
